import endpoints from "../constants/env/middletier";
import React, { useState, useEffect, useRef} from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useProject } from "../context/ProjectContextProvider";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import { useAuth } from '../AuthProvider'

export default function ProjectContextDropdown({onProjectChange}) {
    const [allProjects, setAllProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const { project, setProject } = useProject();
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState('top');
    const { keycloak } = useAuth()

    const fetchProjects = async () => {
        try {
            await keycloak.updateToken(30);

            const response = await fetch(`${endpoints.projectslookup}`, {
            // const response = await fetch(Endpoints["projectslookup"], {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });

            if (!response.ok) throw new Error("Bad response");
            const data = await response.json();
            setAllProjects(data);
       } catch (error) {
            console.error("Failed to fetch clients:", error);
        }
    };

    useEffect(() => {
        fetchProjects();
    }, []);


    const downloadWorkbook = async (projectId) => {

        console.log("Downloading");
        await keycloak.updateToken(30);

        const response = await fetch(
            `${endpoints.workbookexport}${projectId}/workbook`,
            {
                headers: {
                    Authorization: `Bearer ${keycloak.token}`,
                },
            }
        );

        if (!response.ok) {
            throw new Error(`Workbook download failed: HTTP ${response.status}`);
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = `project-${projectId}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Release the object URL after the browser has initiated the download.
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
    };

    const footerContent = (
        <div>
            <Button label="Cancel" icon="pi pi-times" onClick={() => setVisible(false)} autoFocus />
        </div>
    );

    const onCellSelect = (event) => {
        setProject(event.rowData);
        onProjectChange(event.rowData.value);

        console.log(event);
        downloadWorkbook(event.rowData.value).catch(console.error)
        setVisible(false);
    };

    const onDownload = (event) => {
        setProject(event);
        onProjectChange(event.value);

        console.log(event);
        downloadWorkbook(event.value).catch(console.error)
        setVisible(false);
    };


    const downloadBodyTemplate = (product) => {
        return <Button icon="pi pi-download" rounded text severity="info" onClick={() => onDownload(product)} aria-label="Download" />;
    };

    return (
        <>
            <div className="card flex">
                {project && allProjects.length > 0 && (<Button label={`[${project.label}]`} text icon="pi pi-building" severity="secondary"
                        onClick={() => setVisible(true)} />)}
                <Dialog header="Change Project" visible={visible} style={{ width: '50vw' }} position={position}
                        modal={false} onHide={() => setVisible(false)} footer={footerContent}>
                    <DataTable value={allProjects}
                               cellSelection selectionMode="single" selection={selectedProject}
                               onCellSelect={onCellSelect}
                               dataKey="value"
                               scrollable>
                        <Column field="label" header="Project"></Column>
                        <Column header="Download" body={downloadBodyTemplate}></Column>
                    </DataTable>
                </Dialog>
            </div>
            <br />
        </ >
    );
}
